
import Vue from "vue";
import { NewLongStayAlertsApiFunc, setAccessToken } from "@/api";
import { Alert } from "@/models";

import AlertLongStayList from "./components/AlertLongStayList.vue";
import Pager from "@/components/BasePager.vue";
import TheTemplate from "../TheTemplate.vue";
import ActiveAlertLongStayList from "./components/ActiveAlertLongStayList.vue";

export type FilterCondition = {
  alertType?: string;
  status?: string;
  toiletType?: string;
};

export type DataType = {
  alerts: Array<Alert>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
  isActiveMode: boolean;
  isHistoryMode: boolean;
  activeAlerts: Array<Alert>;
};

export default Vue.extend({
  name: "AlertLongStayListScreen",

  data(): DataType {
    return {
      alerts: [],
      filterCondition: {
        alertType: "",
        status: "",
        toiletType: "",
      },
      totalPage: 0,
      currentPage: 0,
      isActiveMode: true,
      isHistoryMode: false,
      activeAlerts: [],
    };
  },

  mounted() {
    this.fetchLongStayAlerts();
    this.fetchActiveLongStayAlerts();
  },

  components: {
    TheTemplate,
    AlertLongStayList,
    ActiveAlertLongStayList,
    Pager,
  },

  methods: {
    async fetchLongStayAlerts(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        alertType: this.filterCondition.alertType,
        status: this.filterCondition.status,
        toiletType: this.filterCondition.toiletType,
      });
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewLongStayAlertsApiFunc().listAlerts(companyId, filterString, page);
      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchLongStayAlerts(page);
        });
        return;
      }

      this.alerts = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    async fetchActiveLongStayAlerts(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        alertType: this.filterCondition.alertType,
        status: "発生",
        toiletType: this.filterCondition.toiletType,
      });
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewLongStayAlertsApiFunc().listActiveAlerts(companyId, filterString, page);
      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchActiveLongStayAlerts(page);
        });
        return;
      }

      this.activeAlerts = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition);
    },

    changePage(page: number): void {
      if (this.isActiveMode) {
        this.fetchActiveLongStayAlerts(page);
      } else {
        this.fetchLongStayAlerts(page);
      }
    },
    setActiveMode(): void {
      this.isActiveMode = true;
      this.isHistoryMode = false;
      this.currentPage = 1;
    },
    setHistoryMode(): void {
      this.isActiveMode = false;
      this.isHistoryMode = true;
      this.currentPage = 1;
    }
  },
});
